// Shared post-auth seam so login-modal / create-account can trigger
// swatchbook merge (and any other after-login work) without importing login.js
// (which would create a circular dependency).

let afterAuthHandler = null;

const setAfterAuthHandler = (handler) => {
  afterAuthHandler = handler;
};

const runAfterAuth = (callback) => {
  if (typeof afterAuthHandler === 'function') {
    afterAuthHandler(callback);
  } else if (typeof callback === 'function') {
    callback();
  }
};

export {
  setAfterAuthHandler,
  runAfterAuth,
};
